<template>
  <button
    :type="type"
    class="block border-2 border-nucleus-primaryBlue text-nucleus-text hover:bg-nucleus-primaryMouseOver hover:text-white p-3 text-lg text-center shadow-md rounded-full transition w-full"
    :class="{ 'border-nucleus-error hover:bg-nucleus-error': error }"
  >
    {{ name }}
  </button>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    name: String,
    type: String,
    error: Boolean,
  },
})
export default class ButtonOutlined extends Vue {}
</script>
